import { type FC } from "react";
import { Link } from "react-router";

// Markup transcribed from the design port kit (sections/Hero.html). The three
// overlay cards are pure HTML+CSS graphics, not images — see the kit's
// CSS-GRAPHICS-INVENTORY.md. Do not rebuild them.
export const Hero: FC = () => (
  <section className="hero">
    <div className="wrap">
      <div className="herogrid">
        <div>
          <div className="eyebrow">
            CASE INTELLIGENCE WORKBENCH DESIGNED BY MED-LEGAL EXPERTS
          </div>
          <h1>From records to reports. One workbench to master your case.</h1>
          <p className="sub">
            Workflow Labs gets you through the record, cites every finding to
            the page, and helps you evaluate every case with confidence.
          </p>
          <Link className="btn" to="/demo">
            Book a demo
          </Link>
        </div>
        <div className="heroart" aria-hidden="true">
          <div className="chron">
            <h4>Case file · Cited chronology</h4>
            <div className="crow" style={{ borderTop: "none" }}>
              <span className="d">03/14/22</span>
              <span className="t">Lumbar MRI — L4-L5 disc protrusion</span>
              <span className="cite">p. 412</span>
            </div>
            <div className="crow">
              <span className="d">06/02/22</span>
              <span className="t">Orthopedic consult — surgical candidate</span>
              <span className="cite">p. 897</span>
            </div>
            <div className="crow hl">
              <span className="d">09/21/23</span>
              <span className="t">
                Evaluation — <b>range of motion</b> deficits documented
              </span>
              <span className="cite">p. 1,847</span>
            </div>
          </div>
          <div className="trace">
            <div className="trow">
              <span className="tk">✓</span>Reading through the report{" "}
              <span className="muted2">— 14 passes</span>
            </div>
            <div className="trow">
              <span className="tk">✓</span>Searching source pages{" "}
              <span className="muted2">— “range of motion” +11 more</span>
            </div>
            <div className="trow">
              <span className="spin"></span>Cross-checking against the record…
            </div>
          </div>
          <div className="pillnote">
            <b style={{ color: "#127772" }}>✓ 13 items verified</b> ·{" "}
            <b style={{ color: "#9a5b00" }}>3 critical found</b> · every finding
            cited to the page
          </div>
        </div>
      </div>
    </div>
  </section>
);
